export default {
  errorsRootKey: 'invoice/agreement',
  resource: 'invoice/agreement',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
